export default __webpack_public_path__ + "static/media/banner2.1474f9a2.jpg";